import { Badge, NativeSelect } from '@chakra-ui/react';
import type { TitlingStage } from '@/lib/api';

export const TITLING_STAGES: TitlingStage[] = ['desmembrado', 'escriturado', 'finalizado'];

export const TITLING_STAGE_LABEL: Record<TitlingStage, string> = {
  desmembrado: 'Desmembrado',
  escriturado: 'Escriturado',
  finalizado: 'Finalizado',
};

const PALETTE: Record<TitlingStage, string> = {
  desmembrado: 'blue',
  escriturado: 'purple',
  finalizado: 'green',
};

export function titlingStageLabel(stage: TitlingStage | null): string {
  return stage ? TITLING_STAGE_LABEL[stage] : 'No iniciado';
}

export function TitlingStageBadge({ stage }: { stage: TitlingStage | null }) {
  return <Badge colorPalette={stage ? PALETTE[stage] : 'gray'}>{titlingStageLabel(stage)}</Badge>;
}

export function TitlingStageSelect({
  value,
  onChange,
  disabled,
  size = 'sm',
}: {
  value: TitlingStage | null;
  onChange: (next: TitlingStage | null) => void;
  disabled?: boolean;
  size?: 'sm' | 'md';
}) {
  return (
    <NativeSelect.Root size={size} maxW="44" disabled={disabled}>
      <NativeSelect.Field
        aria-label="Escrituración"
        value={value ?? ''}
        onChange={(e) => onChange((e.currentTarget.value || null) as TitlingStage | null)}
      >
        <option value="">No iniciado</option>
        {TITLING_STAGES.map((s) => (
          <option key={s} value={s}>
            {TITLING_STAGE_LABEL[s]}
          </option>
        ))}
      </NativeSelect.Field>
      <NativeSelect.Indicator />
    </NativeSelect.Root>
  );
}
